import MasterLayout from "../components/layouts/MasterLayout";
import MainSearch from "../components/search/MainSearch";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { CLEAR_SHOW_MORE_COLLECTION_LIST, FETCH_SHOW_MORE_COLLECTION_LIST } from "../redux/actions";
import ShowMoreProductList from "../components/products/ShowMoreProductList";

const ShowMoreCollectionPage = () => {

    const { t } = useTranslation();


    const dispatch = useDispatch();
    const { showMoreCollectionData } = useSelector((state) => state.showMoreCollectionData);
    const selectedId = useSelector((state) => state.selectItemDrawerMenu.selectedId);
    const currentPage = useSelector((state) => state.currentPage.currentPage);


    useEffect(() => {
        dispatch({ type: CLEAR_SHOW_MORE_COLLECTION_LIST });
        dispatch({ type: FETCH_SHOW_MORE_COLLECTION_LIST });
    }, [selectedId, dispatch, currentPage]);

    return (
        <MasterLayout>
            <MainSearch />
            <ShowMoreProductList data={showMoreCollectionData} status={'collection'} />
        </MasterLayout>
    )
}

export default ShowMoreCollectionPage
